export const getQrCodeImage = (state) => state.auth.mfa.qrCodeImage;
export const getSecret = (state) => state.auth.mfa.secret;
export const getVerificationToken = (state) => state.auth.mfa.verificationToken;
